var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "raphael:dollar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_215_158",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 13.8846 20.4084 15.7216 19.3086 17.252C18.2089 18.7825 16.6564 19.929 14.8702 20.5301C13.0841 21.1311 11.1543 21.1562 9.35303 20.602C7.5518 20.0477 5.97 18.942 4.83072 17.4407C3.69144 15.9395 3.05217 14.1185 3.00306 12.2345C2.95394 10.3506 3.49747 8.49876 4.55698 6.94021C5.6165 5.38165 7.13853 4.19501 8.90844 3.54765C10.6784 2.90028 12.6068 2.82485 14.4219 3.33199L14.0651 4.60891C12.5174 4.17648 10.8731 4.2408 9.36387 4.7928C7.8547 5.3448 6.55688 6.35663 5.65345 7.68559C4.75002 9.01455 4.28656 10.5936 4.32844 12.2C4.37032 13.8064 4.91542 15.3591 5.88686 16.6392C6.85831 17.9193 8.20708 18.8621 9.74297 19.3348C11.2789 19.8074 12.9244 19.7859 14.4474 19.2734C15.9705 18.761 17.2942 17.7833 18.232 16.4783C19.1697 15.1734 19.6742 13.607 19.6742 12H21Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 13.8846 20.4084 15.7216 19.3086 17.252C18.2089 18.7825 16.6564 19.929 14.8702 20.5301C13.0841 21.1311 11.1543 21.1562 9.35303 20.602C7.5518 20.0477 5.97 18.942 4.83072 17.4407C3.69144 15.9395 3.05217 14.1185 3.00306 12.2345C2.95394 10.3506 3.49747 8.49876 4.55698 6.94021C5.6165 5.38165 7.13853 4.19501 8.90844 3.54765C10.6784 2.90028 12.6068 2.82485 14.4219 3.33199L14.0651 4.60891C12.5174 4.17648 10.8731 4.2408 9.36387 4.7928C7.8547 5.3448 6.55688 6.35663 5.65345 7.68559C4.75002 9.01455 4.28656 10.5936 4.32844 12.2C4.37032 13.8064 4.91542 15.3591 5.88686 16.6392C6.85831 17.9193 8.20708 18.8621 9.74297 19.3348C11.2789 19.8074 12.9244 19.7859 14.4474 19.2734C15.9705 18.761 17.2942 17.7833 18.232 16.4783C19.1697 15.1734 19.6742 13.607 19.6742 12H21Z",
    stroke: "#15318D",
    strokeWidth: 3,
    strokeDasharray: "6 6",
    mask: "url(#path-1-inside-1_215_158)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9799 10.2L11.4115 10.8284L10.392 9.70133V15.5556H9.58794V9.70133L8.56925 10.8284L8 10.2L9.98995 8L11.9799 10.2ZM16 13.8L14.01 16L12.0201 13.8L12.5885 13.1716L13.6084 14.2987L13.608 8.44444H14.4121V14.2987L15.4316 13.1716L16 13.8Z",
    fill: "#15318D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE7);
export default __webpack_public_path__ + "static/media/e7.156cbefdb639b3171cfae58490b3f130.svg";
export { ForwardRef as ReactComponent };